{
    "apply": "Apply",
    "top_navbar__search-placeholder": "Search customers, items, orders, etc.",
    "top_navbar__new_actvity": "Create New",
    "top_navbar__new_task": "New Task",
    "top_navbar__new_draft": "New Draft",
    "top_navbar__new_event": "Schedule event",
    "top_navbar__new_note": "Log interaction",
    "search__label__customers": "Customers",
    "search__label__products": "Products",
    "search__label__sales_orders": " Orders",
    "search__label__sales_quotes": "Quotes",
    "search__label__all": "All",
    "search__clear": "Clear search",
    "search__match_label__contact": "Contact",
    "search__match_label__address": "Address",
    "search__match_label__supplier": "Supplier",
    "search__match_label__purchase_order_number": "Purchase order no.",
    "search__match_label__po_number": "PO Number",
    "search__match_label__gtin": "GTIN",
    "search__match_label__ean": "EAN",
    "table_count_results_plural": "Results",
    "table_count_results_singular": "Result",
    "table_more_results": "More results",
    "page_title__home": "Home",
    "page_title__customers": "Customers",
    "page_title__product_details": "Product details",
    "page_title__sales_quotes": "Quotes",
    "page_title__sales_orders": "Orders",
    "page_title__explorer": "Sales Reports",
    "page_title__sales_drafts": "Drafts",
    "page_title__tasks": "Tasks",
    "page_title__drafts": "Drafts",
    "page_title__transactions": "Transactions",
    "page_title__events": "Events",
    "page_title__activities": "Activities",
    "page_title__my_activity": "My Activity",
    "nav_group__steer": "Steer",
    "nav_group__analyze": "Analyze",
    "nav__expand": "Expand navigation",
    "data_freshness__stale": "Data may be outdated",
    "data_freshness__stale_detail_one": "No new orders in Plato for over {{count}} day. Contact your IT if the issue persists.",
    "data_freshness__stale_detail_other": "No new orders in Plato for over {{count}} days. Contact your IT if the issue persists.",
    "view_switch__view_as_label": "View",
    "view_switch__manager": "Manager",
    "view_switch__sales_rep": "Sales Rep",
    "view_switch__rep_only_page_toast": "You can only see this page in Rep mode",
    "view_switch__manager_only_page_toast": "You can only see this page in Manager mode",
    "page_sub_title__home": "Here you see how your day and your month are going and which of your customers need attention right now. Your numbers for today and the month, tasks that are due, and customers with potential or decline. Click a tile or a customer for the details.",
    "page_sub_title__customers": "Here you find which of your customers need an appointment next. You see the customers you are responsible for, with figures and status as in your ERP. The quick views above are ready-made lists for that.",
    "page_sub_title__sales_quotes": "Here you keep track of which of your customers' quotes are still open and should be followed up. They come from your ERP. Filter the list the way you need it and save it as a view for next time.",
    "page_sub_title__sales_orders": "Here you see what your customers have ordered and whether an order is still open or already invoiced. The orders come from your ERP. Filter the list the way you need it and save it as a view for next time.",
    "page_sub_title__explorer": "Here you see what your business is built on and where it falls short of last year, by customer, item and more, as in your ERP. Pick a row as a filter and every other tab shows only what belongs to it.",
    "page_sub_title__customer_explorer": "Here you see what this customer's business with you is built on and where it falls short of last year, by item and more. Pick a row as a filter and every other tab shows only what belongs to it.",
    "page_sub_title__tasks": "Here you see what needs doing today and what is still ahead. Your tasks sit under Today, Upcoming and Completed. The red number in the navigation counts your open tasks due today or earlier.",
    "page_sub_title__drafts": "Here you pick up where you left off on a quote or order. Drafts are what you started in Plato but haven't sent to the ERP yet. Only after sending do they exist there and count.",
    "page_sub_title__events": "Here you plan your visits and meetings with customers. An appointment counts as a visit at the customer only once you log it afterwards.",
    "page_sub_title__activities": "Logged interactions, completed tasks, sales recommendations and customer status changes across the team. Quotes and orders are not included. Planned events, open tasks and pinned notes do not appear here either: find them under Tasks and on the customer page.",
    "page_sub_title__my_activity": "Your logged interactions, completed tasks, sales recommendations and customer status changes. Quotes and orders are not included. Planned events, open tasks and pinned notes do not appear here either: find them under Tasks and on the customer page.",
    "empty_table__no_results": "No Results",
    "form__submit": "Submit",
    "form__cancel": "Cancel",
    "form__close": "Close",
    "form__undo": "Undo",
    "form__delete": "Delete",
    "form__release": "Release",
    "show_results": "Show Results",
    "show_more": "Show more",
    "show_less": "Show less",
    "no_data": "No data",
    "nothing_found": "Nothing found",
    "loading": "Loading",
    "loading_dots": "Loading...",
    "submit": "Submit",
    "search": "Search",
    "quote": "Quote",
    "sales_quote": "Quote",
    "order": "Order",
    "sales_order": "Order",
    "today": "Today",
    "yesterday": "Yesterday",
    "tomorrow": "Tomorrow",
    "difference": "Difference",
    "back": "Back",
    "ascending": "Ascending",
    "descending": "Descending",
    "placeholder__select_date": "Select a date...",
    "description": "Description",
    "logout__button": "Log out",
    "exit_demo__button": "Exit Demo",
    "support__button": "Support",
    "settings__button": "Settings",
    "settings__language_label": "Language",
    "settings__default_metric_label": "Metric",
    "settings__default_metric_description": "The default metric shown throughout Plato.",
    "settings__metric_revenue": "Revenue",
    "settings__metric_order_sum": "Order Sum",
    "settings__default_timeframe_label": "Timeframe",
    "settings__default_timeframe_description": "The default timeframe shown throughout Plato.",
    "settings__timeframe_ytd": "Year to date",
    "settings__timeframe_ttm": "Past 12 months",
    "customer_mode__button": "Hide margins",
    "customer_mode__title": "Enable customer view",
    "customer_mode__sub_title": "Hides internal information such as margins across Plato.",
    "related_to": "Related to",
    "assigned_to_user": "Assigned to {{user}}",
    "assigned_to": "Assigned to",
    "placeholder__select_customer": "Select a customer...",
    "form__customer_required": "Please select a customer",
    "form__text_required": "Please enter text",
    "form__date_required": "Please select a date",
    "form__assignee_required": "Please select a user",
    "vs_lytd": "vs. same period last year",
    "vs_previous_12_months": "compared to previous 12 months",
    "last_12_months": "Last 12 months",
    "previous_12_months": "Previous 12 months",
    "total_amount": "Total",
    "due_date": "Due Date",
    "task": "Task",
    "scheduled_by_user": "scheduled by {{user}}",
    "logged_by_user": "logged by {{user}}",
    "customer": "Customer",
    "article": "Article",
    "product": "Product",
    "storage_location": "Storage location",
    "sales_draft__new_form___title": "New transaction",
    "sales_draft__new_form___storage_location": "Warehouse",
    "sales_draft__new_form___customer": "Customer",
    "sales_draft__new_form___type": "Type",
    "sales_draft__new_form___order": "Order",
    "sales_draft__new_form___quote": "Quote",
    "erp_connection_error_banner___title": "Draft/Order creation disabled",
    "erp_connection_error_banner___description": "Plato is unable to connect to ERP system. Please contact your local IT admin.",
    "placeholder__select_storage": "Select a warehouse...",
    "backorder": "Backorder",
    "search_product": "Search for products",
    "copy_id_tooltip": "Copy the ID to your clipboard",
    "copy_id_name_tooltip": "Copy the ID and name to your clipboard",
    "copy_tooltip": "Copy to clipboard",
    "all_changes_saved": "All changes saved",
    "saving_failed": "Saving failed",
    "time_picker__time_option": "{{time}}",
    "time_picker__placeholder": "Select a time",
    "toast__created_success_body": "You can view it <linkTag>here</linkTag>",
    "toast__edited_success_body": "You can view it <linkTag>here</linkTag>",
    "toast__deleted_success_body": "You can create a new one <linkTag>here</linkTag>",
    "filter_view_updated_title": "View saved and applied.",
    "print": "Print",
    "show_all": "Show all",
    "voice__start_recording": "Start recording",
    "voice__mic_error_title": "Couldn't start recording",
    "voice__mic_error_description": "We couldn't access your microphone. Please check your browser permissions and try again.",
    "voice__transcription_error_title": "Couldn't turn the recording into text",
    "voice__transcription_error_description": "Please try again. If the problem persists, type your note instead.",
    "voice__recording_title": "Recording",
    "voice__processing": "Processing recording …",
    "voice__done": "Done",
    "rich_text_editor__enter_url": "Enter URL:",
    "rich_text_editor__format_bold": "Bold",
    "rich_text_editor__format_italic": "Italic",
    "rich_text_editor__format_underline": "Underline",
    "rich_text_editor__format_strikethrough": "Strikethrough",
    "rich_text_editor__insert_bullet_list": "Bullet list",
    "rich_text_editor__insert_numbered_list": "Numbered list",
    "rich_text_editor__insert_link": "Link",
    "rich_text_editor__more_options": "More options",
    "rich_text_editor__clear": "Clear input",
    "rich_text_editor__improve_writing_loading": "Text is being improved",
    "rich_text_editor__improve_writing": "Improve text",
    "rich_text_editor__heading_summary": "Summary:",
    "rich_text_editor__heading_opportunities": "Opportunities:",
    "rich_text_editor__heading_feedback": "Feedback:",
    "rich_text_editor__heading_next_steps": "Next steps:",
    "rich_text_editor__rate_suggestion": "How do you rate this suggestion?",
    "rich_text_editor__thumbs_up": "Thumbs up",
    "rich_text_editor__thumbs_down": "Thumbs down",
    "rich_text_editor__alternative": "Alternative",
    "rich_text_editor__insert": "Insert",
    "rich_text_editor__feedback_thank_you": "Thank you for your feedback",
    "show_details": "Show details",
    "status_new": "New",
    "status_active": "Active",
    "status_at_risk": "At risk",
    "status_inactive": "Inactive",
    "status_blocked": "Blocked",
    "status_dormant": "Dormant",
    "view_customer": "View customer",
    "more": "more",
    "yes_no__true": "Yes",
    "yes_no__false": "No",
    "not_set": "Not set",
    "select_user": "Select user",
    "select_team_member": "Select team member",
    "you": "You",
    "writeback_error": "An error occurred connecting to the ERP",
    "attachments__label": "Attachments",
    "attachments__add_files": "Add files",
    "attachments__load_error": "Couldn't load file",
    "discard_changes__title": "Discard unsaved changes?",
    "discard_changes__description": "Any data not previously saved will be lost.",
    "discard_changes__confirm": "Discard changes",
    "not_found_page__title": "Page not found",
    "not_found_page__description": "Sorry, we couldn't find the page you're looking for.",
    "not_found_page__back_home": "Back to home",
    "not_found_drawer__title": "Content not found",
    "not_found_drawer__description": "Sorry, we couldn't find the content you're looking for.",
    "error_page__title": "Error",
    "error_page__description": "Sorry, something went wrong (error ID: {{eventId}}):",
    "error_page__try_again": "Try again",
    "mobile_nav__more": "More",
    "nav__webshop": "Webshop",
    "carousel__previous_slide": "Previous slide",
    "carousel__next_slide": "Next slide",
    "aria__main_navigation": "Main navigation",
    "aria__remove": "Remove",
    "aria__select_row": "Select row",
    "aria__tabs": "Tabs"
}
